<template>
  <el-menu
      class="el-menu"
      :default-active="activeIndex"
      background-color="#606F72FF"
      text-color="#ffffff"
      :collapse="isCollapse">

    <div style="display: flex; flex-direction: column; align-items: center; margin-top: 20px">
      <div style="height: 30px">
        <el-image title="我的音乐" :src="require ('@/assets/logo.png')" alt="" style=" height: 100% "></el-image>
      </div>
      <h2 :style="titleSize">
        {{title}}
      </h2>
    </div>
    <!--<el-image :src="require ('@/assets/logo.png')" alt="" style="width: 20px; height: 20px "></el-image>-->
    <!--<h2 :style="titleSize">-->
    <!--  {{title}}-->
    <!--</h2>-->
    <hr>
    <!--通过menu菜单数据来动态生成菜单-->
    <template v-for="item in routeMenu">
      <el-menu-item v-if="!item.meta.multilevel" :index="item.path" :key="item.path" @click="clickMenu(item)">
        <i :class="item.meta.icon"></i>
        <span slot="title">{{ item.meta.title}}</span>
      </el-menu-item>
      <!--这里的index必须是唯一的，否则会导致多个同级的submenu一起展开或收起。index也不能为空，否则激活状态的菜单项刷新页面后不会自动展开-->
      <el-submenu v-else :key="item.path" :index="item.path">
        <template slot="title">
          <i :class="item.meta.icon"></i>
          <span slot="title">{{item.meta.title}}</span>
        </template>
        <template v-for="item2 in item.children">
          <el-menu-item v-if="!item2.meta.multilevel" :key="item2.path" :index="item2.path" @click="clickMenu(item2)">
            <i :class="item2.meta.icon"></i>
            <span slot="title">{{ item2.meta.title}}</span>
          </el-menu-item>
          <el-submenu v-else :key="item2.path" :index="item2.path">
            <template slot="title">
              <i :class="item2.meta.icon"></i>
              <span slot="title">{{item2.meta.title}}</span>
            </template>
            <el-menu-item v-for="subItem in item2.children" :key="subItem.path" :index="subItem.path" @click="clickMenu(subItem)">
              <i :class="subItem.meta.icon"></i>
              <span slot="title">{{ subItem.meta.title}}</span>
            </el-menu-item>
          </el-submenu>
        </template>

      </el-submenu>
    </template>

  </el-menu>
</template>

<script>
import {mapState} from 'vuex'
export default {
  name: "CommonAside",
  data() {
    return {

    }
  },
  methods: {
    // 使用编程式导航可以自定义push还是replace
    clickMenu(item) {
      /*
      * 通过this.$route.matched获取不到当前路由的真实地址。所以这里通过点击菜单的item（这是一个路由对象）获取要跳转的路径
      * */
      // .catch(err => {err})用来捕获连续点击同一个菜单项时，控制台的报错：Avoided redundant navigation to current location ...
      this.$router.push({
        path: item.path
      }).catch(err => {err})
      this.$store.commit('header/handleBreadCrumb', item)
      this.$store.commit('header/addTag', item)
    }
  },
  mounted() {
    // console.log('routes=', this.$route)
    // console.log(this.routeMenu)
  },
  computed: {
    activeIndex() {
      // 根据根路由去匹配
      const rootPath = this.$route.path.split('/')[1];
      return '/' + rootPath;
    },
    // 使用...mapState映射```state```中的数据为计算属性。需要import {mapState} from 'vuex'
    ...mapState('aside',["isCollapse","titleSize","title"]),
    routeMenu() {
      // 从配置的路由中过滤出需要添加到导航栏的路由
      const routMenus = this.$router.options.routes.filter((item) => {
        return item.children
      });
      return routMenus[0].children
    }
  },
}
</script>

<style lang="less" scoped>
  .el-menu:not(.el-menu--collapse) {
    width: 180px;
    min-height: 400px;
    .el-menu-item {
      padding: 0 20px;
      min-width: 180px;
    }
  }

  .el-menu {
    height: 100%;
    border: none;
    h2 {
      text-align: center;
      font-size: large;
      line-height: 50px;
      color: white;
      margin: 0;
    }
  }
</style>
